import { dropSitewideDuplicates } from "~/utils/single-page-schema";
import { normalizeHeadSchemaDates } from "~/utils/schema-dates";

// Runs on every head render (SSR and client navigation) after all pages' tags are in.
export default defineNuxtPlugin(() => {
  injectHead().hooks.hook("tags:resolve", (ctx: any) => {
    dropSitewideDuplicates(ctx.tags);
    normalizeHeadSchemaDates(ctx.tags);
  });
});
